import { input, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { ButtonSize, ButtonType, ButtonColor, ButtonVariant } from './types';

import { BooleanTransformer } from '@/app/shared/utils';

import { ProgressSpinner } from '../progress-spinner';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[appButton], a[appButton]',
  standalone: true,
  exportAs: 'app-button',
  templateUrl: './button.html',
  styleUrl: './button.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.type]': 'type()',
    '[attr.disabled]': 'disabledAttribute()',
    '[class]': 'buttonClasses()',
    '[class.loading]': 'loading()',
    '[class.disabled]': '!!disabledAttribute()',
  },
  imports: [ProgressSpinner],
})
export class Button {
  public size = input<ButtonSize>('large');

  public loading = input(false, { transform: BooleanTransformer });

  public variant = input<ButtonVariant>('filled');

  public color = input<ButtonColor>('primary');

  public disabled = input(false, { transform: BooleanTransformer });

  public type = input<ButtonType>('button');

  public disabledAttribute = computed(() => (!this.loading() && !this.disabled() ? null : true));

  public buttonClasses = computed(() => `button ${this.size()} ${this.variant()} ${this.color()}`);
}
